export const LOADING_STARTED = 'LOADING_STARTED';
export const ACCOUNT_LIST_LOADED = 'ACCOUNT_LIST_LOADED';
